module.exports = __webpack_public_path__ + "img/baiji.b101a15f.png";